/**
 * Standard page header: optional icon, title, optional subtitle, optional
 * right-aligned action (button, button group, etc.). Used by admin pages
 * (Organization, Connectors, ...) to keep visual consistency.
 */
import React from 'react';
import { Typography } from 'antd';

const { Title, Text } = Typography;

interface PageHeaderProps {
  icon?: React.ReactNode;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  /** Right-aligned action area (e.g. primary "New X" button). */
  action?: React.ReactNode;
  /** Visual size. "lg" = full page heading, "md" = inline section heading. */
  size?: 'lg' | 'md';
  style?: React.CSSProperties;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  icon,
  title,
  subtitle,
  action,
  size = 'lg',
  style,
}) => {
  const titleLevel: 1 | 2 | 3 | 4 | 5 = size === 'lg' ? 3 : 4;
  const iconSize = size === 'lg' ? 20 : 16;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: action ? 'center' : 'flex-start',
        justifyContent: 'space-between',
        gap: 16,
        marginBottom: 24,
        ...style,
      }}
    >
      <div style={{ minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          {icon && (
            <span style={{ fontSize: iconSize, color: '#1677ff', display: 'inline-flex' }}>
              {icon}
            </span>
          )}
          <Title level={titleLevel} style={{ margin: 0 }}>{title}</Title>
        </div>
        {subtitle && (
          <Text type="secondary" style={{ display: 'block', marginTop: 4, fontSize: 13 }}>
            {subtitle}
          </Text>
        )}
      </div>
      {action && <div style={{ flexShrink: 0 }}>{action}</div>}
    </div>
  );
};

export default PageHeader;
